import { dateFormat } from "../../../../services/Utils/functionService";
import { useTranslation } from "react-i18next";
import { useCustomerRequestsStore } from "../../../../stores/Cac/Customer/customerRequests";

const RequestDetails = () => {
  const { t } = useTranslation();
  //Store
  const { request } = useCustomerRequestsStore();
  
  return (
    <div className="mx-auto h-full w-full max-w-6xl space-y-3 overflow-y-auto pb-3 sm:space-y-4">
      {/* Header Card */}
      <div className="rounded-xl border border-white/20 bg-white/70 p-3 shadow-xl backdrop-blur-md sm:p-6">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
          <h2 className="text-lg font-bold text-gray-700 sm:text-2xl">{t("customerRequests.requestDetails")}</h2>
          <div className="flex items-center space-x-3">
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${
              request?.State?.state === 'En Attente' ? 'bg-yellow-500/20 text-yellow-700' :
              request?.State?.state === 'Délivrée' ? 'bg-blue-500/20 text-blue-700' :
              request?.State?.state === 'Accepté' ? 'bg-green-500/20 text-green-700' :
              request?.State?.state === 'En retard' ? 'bg-orange-500/20 text-orange-700' :
              'bg-gray-500/20 text-gray-700'
            }`}>
              {request?.State?.state}
            </span>
          </div>
        </div>
        
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          <div className="space-y-2">
            <label className="text-sm font-light text-gray-700 uppercase tracking-wide">{t("customerRequests.requestId")}</label>
            <p className="text-gray-700 font-medium">{request?.fakeId || t("common.undefined")}</p>
          </div>
          
          <div className="space-y-2">
            <label className="text-sm font-light text-gray-700 uppercase tracking-wide">{t("common.category")}</label>
            <p className="text-gray-700 font-medium">{request?.CategoryDocRequest?.name || t("common.undefinedFemale")}</p>
          </div>
          
          <div className="space-y-2">
            <label className="text-sm font-light text-gray-700 uppercase tracking-wide">{t("customerRequests.requester")}</label>
            <p className="text-gray-700 font-medium">{request?.User?.fullName || t("common.undefined")}</p>
          </div>
          
          <div className="space-y-2">
            <label className="text-sm font-light text-gray-700 uppercase tracking-wide">{t("customerRequests.createdAt")}</label>
            <p className="text-gray-700 font-medium">{dateFormat(request?.createdAt)}</p>
          </div>
          
          <div className="space-y-2">
            <label className="text-sm font-light text-gray-700 uppercase tracking-wide">{t("customerRequests.limit")}</label>
            <p className="text-gray-700 font-medium">{dateFormat(request?.dueDate)}</p>
          </div>
          
          <div className="space-y-2">
            <label className="text-sm font-light text-gray-700 uppercase tracking-wide">{t("customerRequests.state")}</label>
            <p className="text-gray-700 font-medium">{request?.State?.state || t("common.undefined")}</p>
          </div>
        </div>
      </div>

      {/* Description Card */}
      <div className="rounded-xl border border-white/20 bg-white/70 p-3 shadow-xl backdrop-blur-sm sm:p-6">
        <label className="text-sm font-light text-gray-700 uppercase tracking-wide mb-2 block">{t("customerRequests.description")}</label>
        <div className="min-h-24 rounded-lg bg-white/70 p-3 sm:min-h-[120px] sm:p-4">
          <p className="text-gray-700 whitespace-pre-line leading-relaxed">
            {request?.description || t("customerRequests.noDescription")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RequestDetails;
